export default __webpack_public_path__ + "static/media/EN_14.572d4ccf.svg";